import { render, staticRenderFns } from "./CargaMasiva.vue?vue&type=template&id=06acc166&scoped=true"
import script from "./CargaMasiva.vue?vue&type=script&lang=js"
export * from "./CargaMasiva.vue?vue&type=script&lang=js"
import style0 from "./CargaMasiva.vue?vue&type=style&index=0&id=06acc166&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06acc166",
  null
  
)

export default component.exports